import {
  printReceiptQR, 
  printReceiptBT, 
  printReceiptSerial, 
  payInBT, 
  payInSerial, 
  payInQR,
  payOutBT,
  payOutSerial,
  payOutQR,
  openDayBT,
  openDaySerial,
  openDayQR,
  closeDayBT,
  closeDaySerial,
  closeDayQR,
  printStornoReceiptSerial,
  printStornoReceiptBT,
  printStornoReceiptQR
} from './printCommands'
import {
  fiscatAeeSaleV5,
  fiscatAeeDayOpenV5,
  fiscatAeeDayCloseV5,
  fiscatAeePayInV5,
  fiscatAeePayOutV5,
  fiscatAeeStornoV5
} from './fiscatV5Model'

const fiscatV5Driver = {
  printReceipt: {
    FiscatV5QR: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptQR(fiscalReceipt, printSlip, fiscatAeeSaleV5, deviceParams, sendMessageToWebView)
    },
    FiscatV5BT: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptBT(fiscalReceipt, printSlip, fiscatAeeSaleV5, deviceParams, sendMessageToWebView)
    },
    FiscatV5Serial: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptSerial(fiscalReceipt, printSlip, fiscatAeeSaleV5, deviceParams, sendMessageToWebView)
    }
  },
  printStornoReceipt: {
    FiscatV5QR: async (fiscalReceipt, deviceParams, sendMessageToWebView) => {
      return await printStornoReceiptQR(fiscalReceipt, fiscatAeeStornoV5, deviceParams, sendMessageToWebView)
    },
    FiscatV5BT: async (fiscalReceipt, deviceParams, sendMessageToWebView) => {
      return await printStornoReceiptBT(fiscalReceipt, fiscatAeeStornoV5, deviceParams, sendMessageToWebView)
    },
    FiscatV5Serial: async (fiscalReceipt, deviceParams, sendMessageToWebView) => {
      return await printStornoReceiptSerial(fiscalReceipt, fiscatAeeStornoV5, deviceParams, sendMessageToWebView)
    }
  },
  openDay: {
    FiscatV5QR: async (amount, reserved, deviceParams, sendMessageToWebView) => {
      return await openDayQR("LOCA", amount, fiscatAeeDayOpenV5, deviceParams, sendMessageToWebView)
    },
    FiscatV5BT: async  (amount, reserved, deviceParams, sendMessageToWebView) => {
      return await openDayBT("LOCA", amount, fiscatAeeDayOpenV5, deviceParams, sendMessageToWebView)
    },
    FiscatV5Serial: async  (amount, reserved, deviceParams, sendMessageToWebView) => {
      return await openDaySerial("LOCA", amount, fiscatAeeDayOpenV5, deviceParams, sendMessageToWebView)
    }
  },
  closeDay: {
    FiscatV5QR: async (deviceParams, sendMessageToWebView) => {
      return await closeDayQR(fiscatAeeDayCloseV5, deviceParams, sendMessageToWebView)
    },
    FiscatV5BT: async  (deviceParams, sendMessageToWebView) => {
      return await closeDayBT(fiscatAeeDayCloseV5, deviceParams, sendMessageToWebView)
    },
    FiscatV5Serial: async  (deviceParams, sendMessageToWebView) => {
      return await closeDaySerial(fiscatAeeDayCloseV5, deviceParams, sendMessageToWebView)
    }
  },
  payIn: {
    FiscatV5QR: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInQR(reason, amount, type, fiscatAeePayInV5, deviceParams, sendMessageToWebView, info)
    },
    FiscatV5BT: async  (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInBT(reason, amount, type, fiscatAeePayInV5, deviceParams, sendMessageToWebView, info)
    },
    FiscatV5Serial: async  (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInSerial(reason, amount, type, fiscatAeePayInV5, deviceParams, sendMessageToWebView, info)
    }
  },
  payOut: {
    FiscatV5QR: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutQR(reason, amount, type, fiscatAeePayOutV5, deviceParams, sendMessageToWebView, info )
    },
    FiscatV5BT: async  (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutBT(reason, amount, type, fiscatAeePayOutV5, deviceParams, sendMessageToWebView, info)
    },
    FiscatV5Serial: async  (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutSerial(reason, amount, type, fiscatAeePayOutV5, deviceParams, sendMessageToWebView, info)
    }
  }
}

export {
  fiscatV5Driver
}